var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_vm._l((_vm.projects),function(project){return _c('portfolio-card',{key:project.id,staticClass:"card",attrs:{"project":project}})}),(_vm.projects.length < 1)?_c('p',[_vm._v("Uh oh! There's nothing here :(")]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }